/**
 * ÜRÜN GALERİSİ — FOTOĞRAFI EKRANA SIĞDIRMA
 *
 * Tam genişlik (full-bleed) galeride slaytın yüksekliği yalnızca ekran
 * GENİŞLİĞİNDEN türüyor: slayt genişliği = galeri genişliği / slidesPerView,
 * yüksekliği de CSS'teki `--product-media-aspect-ratio` (ör. 2/3) ile
 * genişliğe bağlı. Ekran yüksekliği hesaba hiç girmiyordu.
 *
 * Sonuç: geniş ama görece kısa masaüstü monitörlerde (2560x1080, 3440x1440,
 * pencere çubukları düşülmüş 27"+ ekranlar) slayt ekrandan taşıyor ve
 * fotoğrafın altı — modelin bacakları, ürünün etek boyu — katlamanın altında
 * kalıyor. Dizüstülerde ekran oranı daha uzun olduğu için sorun görünmüyor.
 *
 * Bu dosya slidesPerView değerini, slayt yüksekliği görünür alana sığacak
 * kadar ARTIRIR. Ayarda seçilen değerin altına asla inmez; yani yeterince
 * uzun ekranlarda tasarım hiç değişmez, yalnızca taşan ekranlarda yan yana
 * bir-iki fotoğraf daha gösterilerek her fotoğraf bütün halinde görünür.
 */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 750px)';
  var SELECTOR = 'swiper-product-gallery[handle="product-gallery"]';
  // Slaytlar sonsuza kadar küçülmesin; bu sınıra rağmen taşma kalırsa
  // mevcut davranışa (sayfayı kaydırarak görme) dönülür.
  var MAX_SLIDES_PER_VIEW = 6;
  // Fotoğrafın altı ile ekranın altı arasında bırakılan pay.
  var BOTTOM_GUTTER = 8;
  // Çok kısa pencerelerde hesabın saçmalamaması için taban.
  var MIN_AVAILABLE_HEIGHT = 320;

  /** CSS'teki "2/3" gibi bir oranı, genişliğe göre yükseklik katsayısına çevirir. */
  function heightPerWidth(gallery) {
    var media = gallery.closest('.main-product__media');
    var raw = media ? getComputedStyle(media).getPropertyValue('--product-media-aspect-ratio') : '';
    var parts = String(raw).trim().split('/');

    if (parts.length === 2) {
      var w = parseFloat(parts[0]);
      var h = parseFloat(parts[1]);
      if (w > 0 && h > 0) return h / w;
    }

    // Oran "auto" ya da okunamıyorsa slaytın kendi ölçüsünden türet.
    var slide = gallery.querySelector('.swiper-slide');
    if (slide && slide.offsetWidth > 0 && slide.offsetHeight > 0) {
      return slide.offsetHeight / slide.offsetWidth;
    }
    return 0;
  }

  /** Galerinin üstündeki her şey (başlık, üst bar) düşüldükten sonra kalan ekran yüksekliği. */
  function availableHeight(swiper) {
    var top = swiper.el.getBoundingClientRect().top + window.scrollY;
    return Math.max(MIN_AVAILABLE_HEIGHT, window.innerHeight - top - BOTTOM_GUTTER);
  }

  function fit(gallery) {
    var swiper = gallery.instance;
    if (!swiper || swiper.destroyed || !swiper.el) return;

    // Ayardaki değer tabandır. Swiper her breakpoint geçişinde params'ı
    // yeniden yazdığı için tabanı bizim değişikliğimizden ÖNCE saklıyoruz.
    var configured = gallery.__configuredSlidesPerView;
    if (typeof configured !== 'number') return;

    if (!window.matchMedia(DESKTOP_QUERY).matches) {
      apply(swiper, configured);
      return;
    }

    var ratio = heightPerWidth(gallery);
    var width = swiper.el.clientWidth;
    if (!ratio || !width) return;

    var gap = swiper.params.spaceBetween || 0;
    var maxSlideHeight = availableHeight(swiper);
    var maxSlideWidth = maxSlideHeight / ratio;

    // Slayt genişliği = (galeri + boşluk) / slidesPerView - boşluk.
    // Bunu maxSlideWidth için çözüp yukarı yuvarlıyoruz.
    var needed = (width + gap) / (maxSlideWidth + gap);
    needed = Math.ceil(needed * 4) / 4; // çeyrek adımlar: 3.5, 3.75, 4 ...

    apply(swiper, Math.min(MAX_SLIDES_PER_VIEW, Math.max(configured, needed)));
  }

  function apply(swiper, slidesPerView) {
    if (swiper.params.slidesPerView === slidesPerView) return;
    swiper.params.slidesPerView = slidesPerView;
    swiper.update();
    if (swiper.params.loop && typeof swiper.loopFix === 'function') swiper.loopFix();
  }

  /**
   * Galeri kendi Swiper örneğini DOMContentLoaded'da kuruyor ve `instance` olarak
   * saklıyor. Sıralamaya güvenmemek için örnek hazır olana kadar kısa aralıklarla yokluyoruz.
   */
  function whenReady(gallery, callback) {
    var attempts = 0;
    var MAX_ATTEMPTS = 60; // ~3 sn

    (function poll() {
      if (gallery.instance) {
        callback();
        return;
      }
      if (++attempts >= MAX_ATTEMPTS) return;
      setTimeout(poll, 50);
    })();
  }

  function schedule(gallery) {
    if (gallery.__fitScheduled) return;
    gallery.__fitScheduled = true;
    window.requestAnimationFrame(function () {
      gallery.__fitScheduled = false;
      fit(gallery);
    });
  }

  function observe(gallery) {
    var swiper = gallery.instance;
    if (!swiper || gallery.__fitBound) return;
    gallery.__fitBound = true;

    // Kurulumdaki (ve her breakpoint'teki) ayar değeri tabanımız.
    gallery.__configuredSlidesPerView = swiper.params.slidesPerView;
    swiper.on('breakpoint', function (instance, params) {
      gallery.__configuredSlidesPerView = params.slidesPerView;
      schedule(gallery);
    });

    window.addEventListener('resize', function () {
      schedule(gallery);
    });
    window.addEventListener('orientationchange', function () {
      schedule(gallery);
    });

    fit(gallery);
  }

  function init() {
    var galleries = document.querySelectorAll(SELECTOR);
    if (!galleries.length) return;

    Array.prototype.forEach.call(galleries, function (gallery) {
      whenReady(gallery, function () {
        observe(gallery);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
